export default __webpack_public_path__ + "static/media/Book1.fb78110f.pdf";